export default __webpack_public_path__ + "static/media/mob_start.49a95a75.webp";